import { z } from 'zod'

export const tagSchema = z.object({
  id: z.string(),
  name: z.string(),
  color: z.number().int().nonnegative(),
})

export type Tag = z.infer<typeof tagSchema>

export const listTagsInputSchema = z.object({
  name: tagSchema.shape.name.optional(),
})
export const createTagInputSchema = tagSchema.omit({ id: true })
export const updateTagInputSchema = tagSchema.pick({ id: true, color: true })
export const bulkDeleteTagInputSchema = z.object({
  ids: tagSchema.shape.id
    .array()
    .min(1, 'Please select at least one tag to delete'),
})

export const objectWithTagsSchema = z.object({
  object_id: z.string(),
  tag_ids: z.array(z.string()),
})
